import { useEffect, useMemo } from 'react';
import { useFlag } from '~/components/Flag';
import { useLandEvents } from '~/components/Land/Event';
import { useInfiniteCategoryNotices } from '~/components/Support';

export const appliedVersion = '2.9.0';
export const isTargetVersion = !!import.meta.env.VITE_VERSION?.match(/^2\.9\.\d/);
export const useUnreadNewCategoryNotices = (category: string, count = 10) => {
  const { data, hasNextPage, fetchNextPage } = useInfiniteCategoryNotices(category, {
    staleTime: 1000 * 60 * 5,
    useErrorBoundary: false,
  });
  const notices = useMemo(() => {
    const result = data?.pages.flatMap((page) => page.documents) || [];
    return result.slice(0, Math.min(count, result.length));
  }, [count, data?.pages]);

  const unreadNewNotices = useMemo(() => {
    const checkedNoticeMap = JSON.parse(localStorage.getItem('NOTICE_ITEM_CHECKED') || '{}');
    return notices.filter((notice) => {
      if (!notice.newBadge) return false;
      if (checkedNoticeMap[notice.id]) return false;
      return true;
    });
  }, [notices]);

  useEffect(() => {
    if (hasNextPage && notices.length < count) {
      fetchNextPage();
    }
  }, [notices, data, hasNextPage, count, fetchNextPage]);

  return unreadNewNotices;
};

export const useNewLand = () => {
  const { data } = useLandEvents();
  const latestWeek = data?.pages[0]?.weekList[0];

  return useFlag({
    name: 'LAND_WEEK',
    value: latestWeek?.week,
    disabled: latestWeek?.status !== 'IN_PROGRESS',
  });
};
